<template>
	<div class="task-box">
		<div class="task-title">T2：职业路径设计（IA）</div>
		<div v-show="!isNextPage">
			<!--  -->
			<div class="task_f">
				<h3 class="label">您当前的职位是？</h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="currentjob" type="text" placeholder="请填写您当前的职位" />
					</div>
				</div>
				<span class="float">{{currentjob.length}}/8</span>
			</div>
			<!--  -->
			<div class="task-p">
				<p><span class="stress">管理</span>发展路径：任管理职位、承担更大管理范围、含独立创业</p>
				<p><span class="stress">专业</span>发展路径：承担更复杂、更前沿、更高级的专业研发任务</p>
				<p><span class="stress">转换</span>发展路径：进入其他价值更大的职位，或增长更快的行业、组织</p>
				<p><span class="stress">其他</span>可能：包括创业、平衡、斜杠等可能</p>
			</div>
			<!-- A -->
			<div class="task_f">
				<h3 class="label mb">从您当前行业、当前职位出发，您在目标行业中，有哪三条发展方向？<span  class="accent">（如果不打算转行，请填写您在本行业的下一步发展方向）</span></h3>
				<h4 class="label mini">目标职位A：</h4>
				<div class="input-box">
					<div>
						<input v-model="firstjob" type="text" placeholder="请填写目标职位A" />
					</div>
				</div>
				<span class="float">{{firstjob.length}}/8</span>
			</div>
			<!--  -->
			<div class="clearfix btn-checkbox">
				<div class="pull-left btn-title">
					选择路径方向
				</div>
				<div class="pull-right btn-chunk">
					<button @click="setChunkIndex('firstjob_path', 1)" :class="firstjob_path === 1 ? 'active' : ''">管理</button>
					<button @click="setChunkIndex('firstjob_path', 2)" :class="firstjob_path === 2 ? 'active' : ''">专业</button>
					<button @click="setChunkIndex('firstjob_path', 3)" :class="firstjob_path === 3 ? 'active' : ''">转换</button>
					<button @click="setChunkIndex('firstjob_path', 4)" :class="firstjob_path === 4 ? 'active' : ''">其它</button>
				</div>
			</div>
			<!--  -->
			<div v-if="!is_main || cid >= 7" class="task_f mt_reset">
				<h3 class="label blank new-bank">在您的城市（或您想去的城市）、该职位的平均年薪大约是多少万？</h3>
				<div class="input-box">
					<div>
						<input v-model="annual_salary_1" type="text" placeholder="请填写一个数字" />
					</div>
				</div>
				<span class="float">{{annual_salary_1.length}}/3</span>
			</div>
			<div class="task_f mt_reset new-reset">
				<h3 class="label blank">参考该职位的任职要求，您目前的<span @click="alertModule = true" class="noun">&nbsp;能力差距&nbsp;</span>有哪些？<span class="accent">（最多列出3个）</span></h3>
				<div class="input-mt">
					<textarea v-model="firstjob_gap" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔"></textarea>
				</div>
				<span class="float">{{firstjob_gap.length}}/46</span>
			</div>
			<hr class="hr" />
			<!-- B -->
			<div class="task_f">
				<h3 class="label">目标职位B：</h3>
				<div class="input-box">
					<div>
						<input v-model="nextjob" type="text" placeholder="请填写目标职位B" />
					</div>
				</div>
				<span class="float">{{nextjob.length}}/8</span>
			</div>
			<!--  -->
			<div class="clearfix btn-checkbox">
				<div class="pull-left btn-title">
					选择路径方向
				</div>
				<div class="pull-right btn-chunk">
					<button @click="setChunkIndex('nextjob_path', 1)" :class="nextjob_path === 1 ? 'active' : ''">管理</button>
					<button @click="setChunkIndex('nextjob_path', 2)" :class="nextjob_path === 2 ? 'active' : ''">专业</button>
					<button @click="setChunkIndex('nextjob_path', 3)" :class="nextjob_path === 3 ? 'active' : ''">转换</button>
					<button @click="setChunkIndex('nextjob_path', 4)" :class="nextjob_path === 4 ? 'active' : ''">其它</button>
				</div>
			</div>
			<!--  -->
			<div v-if="!is_main || cid >= 7" class="task_f mt_reset">
				<h3 class="label blank new-bank">在您的城市（或您想去的城市）、该职位的平均年薪大约是多少万？</h3>
				<div class="input-box">
					<div>
						<input v-model="annual_salary_2" type="text" placeholder="请填写一个数字" />
					</div>
				</div>
				<span class="float">{{annual_salary_2.length}}/3</span>
			</div>
			<div class="task_f mt_reset new-reset">
				<h3 class="label blank">参考该职位的任职要求，您目前的<span @click="alertModule = true" class="noun">&nbsp;能力差距&nbsp;</span>有哪些？<span class="accent">（最多列出3个）</span></h3>
				<div class="input-mt">
					<textarea v-model="nextjob_gap" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔"></textarea>
				</div>
				<span class="float">{{nextjob_gap.length}}/46</span>
			</div>
			<hr class="hr" />
			<!-- C -->
			<div class="task_f">
				<h3 class="label">目标职位C：</h3>
				<div class="input-box">
					<div>
						<input v-model="threejob" type="text" placeholder="请填写目标职位C" />
					</div>
				</div>
				<span class="float">{{threejob.length}}/8</span>
			</div>
			<!--  -->
			<div class="clearfix btn-checkbox">
				<div class="pull-left btn-title">
					选择路径方向
				</div>
				<div class="pull-right btn-chunk">
					<button @click="setChunkIndex('threejob_path', 1)" :class="threejob_path === 1 ? 'active' : ''">管理</button>
					<button @click="setChunkIndex('threejob_path', 2)" :class="threejob_path === 2 ? 'active' : ''">专业</button>
					<button @click="setChunkIndex('threejob_path', 3)" :class="threejob_path === 3 ? 'active' : ''">转换</button>
					<button @click="setChunkIndex('threejob_path', 4)" :class="threejob_path === 4 ? 'active' : ''">其它</button>
				</div>
			</div>
			<!--  -->
			<div v-if="!is_main || cid >= 7" class="task_f mt_reset">
				<h3 class="label blank new-bank">在您的城市（或您想去的城市）、该职位的平均年薪大约是多少万？</h3>
				<div class="input-box">
					<div>
						<input v-model="annual_salary_3" type="text" placeholder="请填写一个数字" />
					</div>
				</div>
				<span class="float">{{annual_salary_3.length}}/3</span>
			</div>
			<div class="task_f mt_reset new-reset">
				<h3 class="label blank">参考该职位的任职要求，您目前的<span @click="alertModule = true" class="noun">&nbsp;能力差距&nbsp;</span>有哪些？<span class="accent">（最多列出3个）</span></h3>
				<div class="input-mt">
					<textarea v-model="threejob_gap" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔"></textarea>
				</div>
				<span class="float">{{threejob_gap.length}}/46</span>
			</div>
			<!-- 按钮 -->
			<div class="task-footer">
				<div @click="goNextPage" :class="[activeNextBtn ? 'active' : '', 'submit-task']">下一步</div>
			</div>
		</div>
		<!-- 第二页 -->
		<div v-show="isNextPage">
			<!-- 1 -->
			<div class="task_f">
				<h3 class="label mb">如果您达到了职位A-{{ firstjob }},那么你再下一步有哪2条可能的发展方向？</h3>
				<h4 class="label mini">目标职位A1：</h4>
				<div class="input-box">
					<div>
						<input v-model="development1_1" type="text" placeholder="请填写目标职位A1" />
					</div>
				</div>
				<span class="float">{{ development1_1.length }}/8</span>
			</div>
			<div class="task_f mt_reset2">
				<h4 class="label mini">目标职位A2：</h4>
				<div class="input-box">
					<div>
						<input v-model="development1_2" type="text" placeholder="请填写目标职位A2" />
					</div>
				</div>
				<span class="float">{{ development1_2.length }}/8</span>
			</div>
			<hr class="hr" />
			<!-- 2 -->
			<div class="task_f">
				<h3 class="label mb">如果您达到了职位B-{{ nextjob }},那么你再下一步有哪2条可能的发展方向？</h3>
				<h4 class="label mini">目标职位B1：</h4>
				<div class="input-box">
					<div>
						<input v-model="development2_1" type="text" placeholder="请填写目标职位B1" />
					</div>
				</div>
				<span class="float">{{ development2_1.length }}/8</span>
			</div>
			<div class="task_f mt_reset2">
				<h4 class="label mini">目标职位B2：</h4>
				<div class="input-box">
					<div>
						<input v-model="development2_2" type="text" placeholder="请填写目标职位B2" />
					</div>
				</div>
				<span class="float">{{ development2_2.length }}/8</span>
			</div>
			<hr class="hr" />
			<!-- 3 -->
			<div class="task_f">
				<h3 class="label mb">如果您达到了职位C-{{ threejob }},那么你再下一步有哪2条可能的发展方向？</h3>
				<h4 class="label mini">目标职位C1：</h4>
				<div class="input-box">
					<div>
						<input v-model="development3_1" type="text" placeholder="请填写目标职位C1" />
					</div>
				</div>
				<span class="float">{{ development3_1.length }}/8</span>
			</div>
			<div class="task_f mt_reset2">
				<h4 class="label mini">目标职位C2：</h4>
				<div class="input-box">
					<div>
						<input v-model="development3_2" type="text" placeholder="请填写目标职位C2" />
					</div>
				</div>
				<span class="float">{{ development3_2.length }}/8</span>
			</div>
			<!-- 上一步， 提交 -->
			<div class="task-submit-box">
				<div @click="isNextPage = false" class="active submit-task">上一步</div>
				<div @click="submitData" :class="[isSubmit ? 'active' : '', 'submit-task']">提交</div>
			</div>
		</div>
		<!-- 弹窗 -->
		<van-popup class="explain" v-model="alertModule">
			<div>
				<h2>能力差距</h2>
				<div class="pps">
						职位和更高级职位之间的能力差。沿着职业路径的能力差，能建立自己的技能树。
				</div>
			</div>
		</van-popup>
		<!-- 下一关 -->
		<van-popup :close-on-click-overlay="false" v-model="nextModule">
			<div class="modules">
				<div class="head clearfix">
					<img @click="goTaskIndex" class="close" src="../../../assets/close.png" alt="" />
				</div>
				<div class="con-img">
					<img src="../../../assets/pr1.png" alt="" />
				</div>
				<div class="con-text">
					任务就像消消乐，完成就好，继续加油！
				</div>
				<router-link class="next-btn" :to="{path: 'project1_task3_new', query: objArg}">去开启下一任务</router-link>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { getresearchdata, updateresearchdata } from "@/api/course"
	import { getStorage, setStorage,isMain } from "@/utils/tools"
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				objArg: {
					id: "",
					cid: "",
					pid: "",
					name: ""
				},
				// 下一关
				nextModule: false,
				// 按钮状态
				activeNextBtn: false,
				// 状态
				isNextPage: false,
				isSubmit: false,
				// 弹窗
				alertModule: false,
				// 第一页
				firstjob_path: 0,
				nextjob_path: 0,
				threejob_path: 0,
				currentjob: "",
				firstjob: "",
				nextjob: "",
				threejob: "",
				firstjob_gap: "",
				nextjob_gap: "",
				threejob_gap: "",
				annual_salary_1:'',
				annual_salary_2:'',
				annual_salary_3:'',
				cid:'',
				// 第二页
				development1_1: "",
				development1_2: "",
				development2_1: "",
				development2_2: "",
				development3_1: "",
				development3_2: ""
			}
		},
		computed: {
			is_main(){
				return isMain()
			}
		},
		methods: {
			// 去首页
			goTaskIndex(){
				let q = this.$route.query;
				this.$router.push({
					path: "/project_details",
					query: {
						cid: q.cid,
						cpid: q.pid,
						type: "trademap"
					}
				})
			},
			submitData(){
				if(!this.isSubmit){
					return
				}
				// 正式提交
				this.commitData();
			},
			commitData(){
				let q = this.$route.query;
				updateresearchdata({
					cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					type: "tasktwo",
					iscreate: 1,
					currentjob: this.currentjob,
					firstjob: this.firstjob,
					firstjob_gap: this.firstjob_gap,
					nextjob: this.nextjob,
					nextjob_gap: this.nextjob_gap,
					threejob: this.threejob,
					threejob_gap: this.threejob_gap,
					firstjob_path: this.firstjob_path,
					nextjob_path: this.nextjob_path,
					threejob_path: this.threejob_path,
					development1: `${this.development1_1}/${this.development1_2}`,
					development2: `${this.development2_1}/${this.development2_2}`,
					development3: `${this.development3_1}/${this.development3_2}`,
					annual_salary_1:(!this.is_main || this.cid >= 7)?this.annual_salary_1:'',
					annual_salary_2:(!this.is_main || this.cid >= 7)?this.annual_salary_2:'',
					annual_salary_3:(!this.is_main || this.cid >= 7)?this.annual_salary_3:''
				// 第二页
				})
				.then((data) => {
					let q = this.$route.query;
					// 参数
					this.objArg = {
						id: data.cptid,
						cid: q.cid,
						pid: q.pid,
						name: encodeURIComponent(data.name)
					}
					// 弹框显示
					this.nextModule = true;
				})
			},
			// 显示下一页
			goNextPage(){
				if(!this.activeNextBtn){
					return
				}
				this.isNextPage = true;
			},
			// 第二页
			changeSubmitState(){
				if(
						this.development1_1.length &&
						this.development1_2.length &&
						this.development2_1.length &&
						this.development2_2.length &&
						this.development3_1.length &&
						this.development3_2.length
				){
					this.isSubmit = true;
				}else{
					this.isSubmit = false;
				}
			},
			// 第一页
			changeNextState(){
				if(
						this.currentjob.length &&
						this.firstjob.length &&
						this.nextjob.length &&
						this.threejob.length &&
						this.firstjob_gap.length &&
						this.nextjob_gap.length &&
						this.threejob_gap.length &&
						(!this.is_main || this.cid >= 7?
						this.annual_salary_1.length &&
						this.annual_salary_2.length &&
						this.annual_salary_3.length :true)
				){
					this.activeNextBtn = true;
				}else{
					this.activeNextBtn = false;
				}
			},
			setChunkIndex(key, index){
				this[key] = index;
			},
			pullData(){
				let cid = this.$route.query.cid;
				this.cid = cid;
				getresearchdata({
					type: "tasktwo",
					cid
				})
				.then((data) => {
					if(typeof data !== 'string'){
						
						this.setDataVal(data.data);
						
					}else{
						let index = data.lastIndexOf('/');
						let path = data.slice(index);
						this.$router.push(path);
					}
				})
			},
			setDataVal(d){
				let path = this.$route.path;
				// 第一页
				this.currentjob = d.currentjob  ? d.currentjob : getStorage(path, 'currentjob') || '';
				this.firstjob = d.firstjob ? d.firstjob : getStorage(path, 'firstjob') || '';
				this.firstjob_gap = d.firstjob_gap ? d.firstjob_gap : getStorage(path, 'firstjob_gap') || '';
				this.nextjob = d.nextjob ? d.nextjob : getStorage(path, 'nextjob') || '';
				this.nextjob_gap = d.nextjob_gap ? d.nextjob_gap : getStorage(path, 'nextjob_gap') || '';
				this.threejob = d.threejob ? d.threejob : getStorage(path, 'threejob') || '';
				this.threejob_gap = d.threejob_gap ? d.threejob_gap : getStorage(path, 'threejob_gap') || '';
				this.firstjob_path = d.firstjob_path  ? d.firstjob_path : getStorage(path, 'firstjob_path') || '';
				this.nextjob_path = d.nextjob_path ? d.nextjob_path : getStorage(path, 'nextjob_path') || '';
				this.threejob_path = d.threejob_path ? d.threejob_path : getStorage(path, 'threejob_path') || '';
				// 第二页
				let dev1 = !d.development1 ? ["",""]:d.development1.split('/');

				this.development1_1 =  dev1[0]? dev1[0] : getStorage(path, 'development1_1') || '';
				this.development1_2 = dev1[1]? dev1[1] : getStorage(path, 'development1_2') || '';

				let dev2 = !d.development2 ? ["",""]:d.development2.split('/');
				this.development2_1 = dev2[0]? dev2[0] : getStorage(path, 'development2_1') || '';
				this.development2_2 = dev2[1]? dev2[1] : getStorage(path, 'development2_2') || '';

				let dev3 = !d.development3 ? ["",""]:d.development3.split('/');
				this.development3_1 = dev3[0]? dev3[0] : getStorage(path, 'development3_1') || '';
				this.development3_2 = dev3[1]? dev3[1] : getStorage(path, 'development3_2') || '';

				this.annual_salary_1 = d.annual_salary_1? d.annual_salary_1 + '' : getStorage(path, 'annual_salary_1') || '';
				this.annual_salary_2 = d.annual_salary_2? d.annual_salary_2 + '' : getStorage(path, 'annual_salary_2') || '';
				this.annual_salary_3 = d.annual_salary_3? d.annual_salary_3 + '' : getStorage(path, 'annual_salary_3') || '';

			},
			setPageTitle(){
				let title = this.$route.query.name;
				document.title = decodeURI(title);
			}
		},
		created(){
			this.pullData();
			this.setPageTitle();
			shareCon("course",this);
		},
		watch: {
			currentjob(curVal, oldVal){
				if(curVal.length > 8) {
		      this.currentjob = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'currentjob', curVal);
		    	this.changeNextState();
		    }
			},
			firstjob(curVal, oldVal){
				if(curVal.length > 8) {
		      this.firstjob = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'firstjob', curVal);
		    	this.changeNextState();
		    }
			},
			nextjob(curVal, oldVal){
				if(curVal.length > 8) {
		      this.nextjob = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'nextjob', curVal);
		    	this.changeNextState();
		    }
			},
			threejob(curVal, oldVal){
				if(curVal.length > 8) {
		      this.threejob = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'threejob', curVal);
		    	this.changeNextState();
		    }
			},
			firstjob_gap(curVal, oldVal){
				if(curVal.length > 46) {
		      this.firstjob_gap = curVal.slice(0, 46);
		      this.$toast('最多只能输入46个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'firstjob_gap', curVal);
		    	this.changeNextState();
		    }
			},
			nextjob_gap(curVal, oldVal){
				if(curVal.length > 46) {
		      this.nextjob_gap = curVal.slice(0, 46);
		      this.$toast('最多只能输入46个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'nextjob_gap', curVal);
		    	this.changeNextState();
		    }
			},
			threejob_gap(curVal, oldVal){
				if(curVal.length > 46) {
		      this.threejob_gap = curVal.slice(0, 46);
		      this.$toast('最多只能输入46个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'threejob_gap', curVal);
		    	this.changeNextState();
		    }
			},
			development1_1(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development1_1 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development1_1', curVal);
		    	this.changeSubmitState();
		    }
			},
			development1_2(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development1_2 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development1_2', curVal);
		    	this.changeSubmitState();
		    }
			},
			development2_1(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development2_1 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development2_1', curVal);
		    	this.changeSubmitState();
		    }
			},
			development2_2(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development2_2 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development2_2', curVal);
		    	this.changeSubmitState();
		    }
			},
			development3_1(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development3_1 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development3_1', curVal);
		    	this.changeSubmitState();
		    }
			},
			development3_2(curVal, oldVal){
				if(curVal.length > 8) {
		      this.development3_2 = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'development3_2', curVal);
		    	this.changeSubmitState();
		    }
			},
			annual_salary_1(curVal, oldVal){
				if(curVal.length > 3) {
		      this.annual_salary_1 = curVal.slice(0, 3);
		      this.$toast('最多只能输入3个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'annual_salary_1', curVal);
		    	this.changeNextState();
		    }
			},
			annual_salary_2(curVal, oldVal){
				if(curVal.length > 3) {
		      this.annual_salary_2 = curVal.slice(0, 3);
		      this.$toast('最多只能输入3个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'annual_salary_2', curVal);
		    	this.changeNextState();
		    }
			},
			annual_salary_3(curVal, oldVal){
				if(curVal.length > 3) {
		      this.annual_salary_3 = curVal.slice(0, 3);
		      this.$toast('最多只能输入3个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'annual_salary_3', curVal);
		    	this.changeNextState();
		    }
			},
			firstjob_path(curVal, oldVal){
		    setStorage(this.$route.path, 'firstjob_path', curVal);
			},
			nextjob_path(curVal, oldVal){
		    setStorage(this.$route.path, 'nextjob_path', curVal);
			},
			threejob_path(curVal, oldVal){
		    setStorage(this.$route.path, 'threejob_path', curVal);
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.task_f{
		margin-top: 30px;
	}
	.mt_reset{
		margin-top: 20px;
	}
	.new-reset,.mt_reset2{
		margin-bottom: 30px;
	}
	.hr{
		border: 0;
		border-bottom:1px solid #ccc;
		height:0;
	}
	.new-bank{
		margin-bottom: 15px;
		font-size: 32px;
		line-height: 42px;
	}
	.noun{
		cursor: pointer;
	}

</style>